var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handle-coupon" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "handle-coupon-body",
        attrs: {
          "element-loading-text": "获取信息中...",
          "element-loading-spinner": "el-icon-loading",
        },
      },
      [
        _c(
          "div",
          { staticClass: "base-info" },
          [
            _c("el-row", { staticClass: "base-info-item" }, [
              _c("label", { staticClass: "item-label" }, [
                _vm._v("促销名称："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(
                  _vm._s(_vm.info.promoResponse && _vm.info.promoResponse.name)
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("el-row", { staticClass: "base-info-item" }, [
              _c("label", { staticClass: "item-label" }, [
                _vm._v("促销时间："),
              ]),
              _vm._v(" "),
              _vm.info.promoResponse
                ? _c("div", { staticClass: "item-value" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.info.promoResponse.startTime || "") +
                          " 至 " +
                          (_vm.info.promoResponse.endTime || "")
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("el-row", { staticClass: "base-info-item" }, [
              _c("label", { staticClass: "item-label" }, [
                _vm._v("促销内容："),
              ]),
              _vm._v(" "),
              _vm.info.promoResponse &&
              _vm.info.promoResponse.promotionDetailStr
                ? _c(
                    "div",
                    { staticClass: "item-value" },
                    _vm._l(
                      _vm.info.promoResponse.promotionDetailStr.split("\n"),
                      function (item, index) {
                        return _c("div", { key: index }, [_vm._v(_vm._s(item))])
                      }
                    ),
                    0
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h3", [_vm._v("促销效果总览")]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cards" },
          _vm._l(_vm.cards, function (item, index) {
            return _c("el-card", { key: index, attrs: { shadow: "always" } }, [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v(_vm._s(item.title))])]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                item.isMark ? _c("span", [_vm._v("￥")]) : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.info[item.value] || "--"))]),
              ]),
            ])
          }),
          1
        ),
        _vm._v(" "),
        _c("h3", [_vm._v("平台效果统计")]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "el-form",
          {
            attrs: {
              inline: true,
              model: _vm.searchForm,
              "label-width": "120px",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "小程序客户：" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "380px" },
                    attrs: { clearable: "", multiple: "" },
                    on: { change: _vm.getDetail },
                    model: {
                      value: _vm.searchForm.customerIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "customerIds", $$v)
                      },
                      expression: "searchForm.customerIds",
                    },
                  },
                  _vm._l(_vm.commonData.distributionCustomers, function (opt) {
                    return _c("el-option", {
                      key: opt.id,
                      attrs: { value: opt.id, label: opt.name },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "统计时间：" } },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "380px" },
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "-",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": _vm.timeFormat,
                  },
                  on: { change: _vm.getDetail },
                  model: {
                    value: _vm.searchForm.time,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "time", $$v)
                    },
                    expression: "searchForm.time",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "show-goods" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                attrs: { data: _vm.tableData.list },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "小程序客户",
                    prop: "customerResponse",
                    align: "center",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                    formatter: _vm.customerFormatter,
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交单量",
                    prop: "transactionVolume",
                    align: "center",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交金额",
                    prop: "totalTransactionAmount",
                    align: "center",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "优惠金额",
                    prop: "totalDiscountAmount",
                    align: "center",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "客单价",
                    prop: "customerUnitPrice",
                    align: "center",
                    width: "200",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交客户数",
                    prop: "customerCount",
                    align: "center",
                    width: "200",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交商品件数",
                    prop: "productItemCount",
                    align: "center",
                    "min-width": "200",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交转化率",
                    prop: "productItemCount",
                    align: "center",
                    "min-width": "200",
                    "show-overflow-tooltip": "",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }